
import '../../static/Footer.css';
import '../../static/Global.css';

function Footer() {
  return (
    <footer className="footer">

      <article className="footer__links">
        <section>
          <h6>Sobre nosotros</h6>
          <ul>
            <li><a href="/reseñas">Reseñas</a></li>
            <li><a href="/aboutus">Contáctanos</a></li>
          </ul>
        </section>
        <section>
          <h6>Soporte</h6>
          <ul>
            <li><a href="/#faq">Preguntas frecuentes</a></li>
          </ul>
        </section>
      </article>

      <section className="footer__copyright">
        Novatech @ 2026. Todos los derechos reservados
      </section>
      
    </footer>
  );
}

export default Footer;